import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '@material-ui/core/Tooltip'
import MuiButton from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

const Button = withStyles({
  root: {
    '&.Mui-disabled': {
      pointerEvents: 'auto'
    }
  }
})(MuiButton)

// custom component that simply wraps Button but adds the ability to have a tooltip display, even if the button is disabled, which normally
// causes an error. See SO: https://stackoverflow.com/questions/61115913/is-it-possible-to-render-a-tooltip-on-a-disabled-mui-button-within-a-buttongroup
export default function ButtonWithTooltip ({ tooltipText, disabled, onClick, ...other }) {
  const adjustedButtonProps = {
    disabled: disabled,
    component: disabled ? 'div' : undefined,
    onClick: disabled ? undefined : onClick
  }

  return (
    <Tooltip title={tooltipText}>
      <Button {...other} {...adjustedButtonProps} />
    </Tooltip>
  )
}

ButtonWithTooltip.propTypes = {
  tooltipText: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}
